/**
 * Maps a prescription order's `fulfillment_partner` to its patient-facing
 * website link and anchor text (e.g. `visit ${label}.`), for insurance-
 * mediated fulfillment pages.
 *
 * Returns `null` when no mapping is known so callers can fall back to
 * non-link copy.
 */

const AMAZON_PHARMACY_URL =
  "https://pharmacy.amazon.com/medicare-glp-1-bridge-program-details";

const AMAZON_PHARMACY_LABEL = "the Amazon Pharmacy website";

export type PharmacyWebsiteLink = {
  url: string;
  label: string;
};

export const getPharmacyWebsiteLink = (
  fulfillmentPartner: string | null | undefined
): PharmacyWebsiteLink | null => {
  if (fulfillmentPartner === "AMAZON_PHARMACY") {
    return { url: AMAZON_PHARMACY_URL, label: AMAZON_PHARMACY_LABEL };
  }
  return null;
};
